import Alternative from './Alternative'

export default Alternative
